import { Component, OnInit } from '@angular/core';
import { Router, NavigationCancel, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter, map, mergeMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { SeoService } from './services/seo.service';
declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent implements OnInit {
    location: any;
    routerSubscription: any;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private translate: TranslateService,
        private seo: SeoService
    ) {}

    ngOnInit() {
        this.recallJsFuntions();
        this.setupSeo();
    }

    recallJsFuntions() {
        this.routerSubscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
        .subscribe(event => {
            this.location = this.router.url;
            if (!(event instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }

    /**
     * SEO: en cada cambio de ruta lee el data {title, description} de la ruta
     * activa y actualiza title/description/canonical/OG. También mantiene
     * <html lang> sincronizado con el idioma activo de la app.
     */
    private setupSeo() {
        // Sincroniza <html lang> con el idioma activo (y cuando cambia)
        this.seo.setHtmlLang(this.translate.currentLang || this.translate.getDefaultLang() || 'en');
        this.translate.onLangChange.subscribe(e => {
            this.seo.setHtmlLang(e.lang);
            // re-aplica el SEO de la ruta actual para traducir el contenido
            this.applyRouteSeo();
        });

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map(route => {
                while (route.firstChild) { route = route.firstChild; }
                return route;
            }),
            filter(route => route.outlet === 'primary'),
            mergeMap(route => route.data)
        ).subscribe(data => {
            const title = data['title'] || 'EFT-Systems';
            const description = data['description'] || '';
            this.seo.updateForRoute(title, description, this.router.url.split('?')[0]);
        });
    }

    private applyRouteSeo() {
        let route = this.activatedRoute;
        while (route.firstChild) { route = route.firstChild; }
        route.data.subscribe(data => {
            const title = data['title'] || 'EFT-Systems';
            const description = data['description'] || '';
            this.seo.updateForRoute(title, description, this.router.url.split('?')[0]);
        });
    }
}
